<template>
    <div class="main_menu_component">
        <button @click="toggleMenu" type="button" class="md-button main_menu_button md-theme-default">
            <div class="md-ripple">
                <div class="md-button-content">
                    <i class="material-icons">menu</i>
                </div>
            </div>
        </button>
        <div class="main_menu_overlay" v-if="mainMenu" @click="toggleMenu" />
        <transition name="slide">
            <div class="main_menu" v-if="mainMenu">
                <div class="md-toolbar">
                    <div class="md-toolbar-section-end">
                        <get-country-domain :menu="true"/>
                    </div>
                    <div class="md-toolbar-section-end">
                        <a
                            :href="loginUrl"
                            class="desktop-login-button main_menu_header_login"
                            >{{ $t('home.login') }}
                        </a>
                        <md-button @click="toggleMenu" class="main_menu_close_button">
                            <i class="material-icons">close</i>
                        </md-button>
                    </div>
                </div>
                <md-list>
                    <md-list-item
                        class="main_menu_item"
                        v-for="item of items"
                        :key="item.id"
                        :href="item.url"
                    >
                        <span class="icon" v-if="item.icon">
                            <img :src="'/imgs/icons/menu/icon-menu-'+item.icon" />
                        </span>
                        <span class="md-list-item-text">{{ item.label }}</span>
                    </md-list-item>
                </md-list>
                <div class="main_menu_social">
                    <div v-for="item in social" :key="item.id">
                        <a :href="item.url[locale]" target="_blank">
                            <img :src="item.image" />
                        </a>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        locale: String,
        items: Array,
        social: Array,
        loginUrl: String,
        showMainMenuLoader: Boolean,
    },
    data() {
        return {
            mainMenu: false,
        };
    },
    mounted() {
        this.$emit('update:showMainMenuLoader', false);
    },
    methods: {
        toggleMenu() {
            if (!this.mainMenu) {
                document.documentElement.style.overflowY = 'hidden';
            } else {
                document.documentElement.style.overflowY = '';
            }
            this.mainMenu = !this.mainMenu;
        },
    },
};
</script>
<style lang="scss">
@import "~styles/_variables";
.main_menu_component {
    .main_menu_overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100vh);
        background: $primary-color-dark;
        opacity: 0.5;
    }
    .main_menu {
        position: absolute;
        right: 0;
        width: 430px;
        @media screen and (max-width: 600px) {
            width: 100%;
        }
        top: 0;
        height: calc(100vh);
        background: white;
        z-index: 6;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        .md-list {
            padding-top: 0px;
            a {
                margin-left: 0 !important;
                padding-left: 32px;
            }
        }
        .md-toolbar {
            border-bottom: 1px solid $primary-color-dark;
            .md-toolbar-section-end {
                .main_menu_header_phone {
                    color: $primary-color !important;
                }
                .main_menu_header_login {
                    color: $primary-color-dark !important;
                }
                .main_menu_close_button {
                    color: $primary-color !important;
                }
            }
        }
        .main_menu_item {
            border-bottom: 1px solid $primary-color-dark;
            a {
                height: 70px;
                text-transform: uppercase;
                color: $primary-color-dark !important;
                font-weight: bold;
                @media screen and (max-width: 600px) {
                    font-size: 13px;
                }
                .icon {
                    width: 50px;
                    display: flex;
                    justify-content: center;
                    margin-right: 30px;
                }
            }
        }
        .main_menu_social {
            display: flex;
            justify-content: space-around;
            padding-bottom: 20px;
            padding-top: 20px;
            div {
                display: flex;
                align-items: center;
                justify-content: center;
                a {
                    margin-left: 0px !important;
                    img {
                        border-radius: 50%;
                        border: 1px solid $primary-color-dark;
                        height: 48px;
                        width: 48px;
                    }
                }
            }
        }
        .main_menu_spacer {
            flex-grow: 1;
        }
    }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active {
    transition: all 0.3s ease;
}
.slide-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(100%);
    opacity: 0;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/MainMenuComponent.vue